import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AppContext from "../../store/App/contexts";

import AppstoreLogo from "../../assets/images/logos/appstore.svg";
import HeraaLogo from "../../assets/images/logos/heraa-logo.png";
import PlaystoreLogo from "../../assets/images/logos/playstore.svg";

import { config } from "../../config";
const { MANPOWER_POLICY_URL } = config;

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [policyUrl, setPolicyUrl] = useState(MANPOWER_POLICY_URL);
  const [policyLabel, setPolicyLabel] = useState(
    "Manpower Global Privacy Policy"
  );
  const [showPassword, setShowPassword] = useState(false);
  const [deviceType, setDeviceType] = useState("unknown");

  const emailHandler = (e) => setEmail(e.target.value);
  const passwordHandler = (e) => setPassword(e.target.value);

  useEffect(() => {
    // Detect device type
    const userAgent = navigator.userAgent.toLowerCase();
    if (/android/.test(userAgent)) {
      setDeviceType("android");
    } else if (/iphone|ipad|ipod/.test(userAgent)) {
      setDeviceType("ios");
    } else {
      setDeviceType("other");
    }

    if (window.location.host.includes("employee")) {
      setPolicyUrl("privacy-policy.pdf");
      setPolicyLabel("Manpower Policy on Staff Privacy");
    }
  }, []);

  const getStoreBadge = () => {
    const badgeStyle = {
      height: "40px",
      width: "auto",
      display: "block",
      margin: "0 auto 20px auto",
    };

    if (deviceType === "android") {
      return (
        <a
          href="https://play.google.com/store/apps/details?id=com.powertrack&pcampaignid=web_share"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            alt="Download on the Play Store"
            src={PlaystoreLogo}
            style={badgeStyle}
          />
        </a>
      );
    } else if (deviceType === "ios") {
      return (
        <a
          href="https://apps.apple.com/sg/app/powertrack-mpsg/id6756564809"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            alt="Download on the App Store"
            src={AppstoreLogo}
            style={badgeStyle}
          />
        </a>
      );
    } else {
      // Desktop or unknown - show both side by side
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "16px",
            marginBottom: "20px",
          }}
        >
          <a
            href="https://play.google.com/store/apps/details?id=com.powertrack&pcampaignid=web_share"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="Download on the Play Store"
              src={PlaystoreLogo}
              style={{ height: "40px", width: "auto", display: "block" }}
            />
          </a>
          <a
            href="https://apps.apple.com/sg/app/powertrack-mpsg/id6756564809"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="Download on the App Store"
              src={AppstoreLogo}
              style={{ height: "40px", width: "auto", display: "block" }}
            />
          </a>
        </div>
      );
    }
  };

  return (
    <AppContext.Consumer>
      {({ loginHandler }) => (
        <main className="login-container">
          <div
            className="login-ambient login-ambient--one"
            aria-hidden="true"
          />
          <div
            className="login-ambient login-ambient--two"
            aria-hidden="true"
          />
          <section className="login-shell" aria-labelledby="login-title">
            <div className="login-brand-panel">
              <div className="login-brand-copy">
                <span className="login-eyebrow">Employee portal</span>
                <h1>Everything you need for work, in one place.</h1>
                <p>
                  Stay connected to your schedule, requests, and documents
                  through a secure, simple workspace.
                </p>
              </div>
              <div className="login-brand-orbit" aria-hidden="true">
                <span />
              </div>
              <div className="login-trust-pill">
                <i className="fas fa-shield-halved" aria-hidden="true" />
                Secure employee access
              </div>
            </div>

            <div className="login-card">
              <div className="login-logo">
                <img src={HeraaLogo} alt="Heraa logo" />
              </div>

              <div className="login-main-input-container">
                <span className="login-mobile-eyebrow">Employee portal</span>
                <h2 id="login-title">Welcome back</h2>
                <p className="login-subtitle">
                  Sign in to continue to your workspace.
                </p>

                <form
                  onSubmit={(e) =>
                    loginHandler("associate", email, password, e)
                  }
                >
                  <label htmlFor="login-email">Email address</label>
                  <input
                    id="login-email"
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => emailHandler(e)}
                    placeholder="name@example.com"
                    autoComplete="email"
                    required
                  />
                  <div className="login-password-row">
                    <label htmlFor="login-password">Password</label>
                    <Link to="/forgot-password">Forgot password?</Link>
                  </div>
                  <div className="login-password-field">
                    <input
                      id="login-password"
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      value={password}
                      onChange={(e) => passwordHandler(e)}
                      placeholder="Enter your password"
                      autoComplete="current-password"
                      required
                    />

                    <button
                      type="button"
                      className="login-password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                    >
                      {showPassword ? (
                        <i className="far fa-eye-slash" aria-hidden="true" />
                      ) : (
                        <i className="far fa-eye" aria-hidden="true" />
                      )}
                    </button>
                  </div>
                  <button
                    className="btn btn-brand btn-lg btn-block login-submit"
                    type="submit"
                  >
                    Sign in{" "}
                    <i className="fas fa-arrow-right" aria-hidden="true" />
                  </button>
                </form>
              </div>

              {/* Store badge - shows based on device type */}
              {/* <div className="login-app-badges">{getStoreBadge()}</div> */}
            </div>
          </section>
        </main>
      )}
    </AppContext.Consumer>
  );
};

export default Login;
